const db = new Dexie("PersonalizationDB");

db.version(1).stores({
  profile: "id, name, gender, dedicationText, imageBase64"
});

// Stores every field it's given (e.g. Bedtime adds skinTone); Dexie only indexes
// the fields listed in stores(), extra fields are stored as-is.
async function saveProfile(profile) {
  try {
    await db.profile.put({
      id: 1,
      ...profile
    });
    console.log("Profile saved.");
  } catch (err) {
    console.error("Error saving profile:", err);
  }
}

async function deleteProfile() {
  try {
    await db.profile.delete(1);
    console.log("Profile deleted.");
  } catch (err) {
    console.error("Error deleting profile:", err);
  }
}

async function loadProfile() {
  try {
    const data = await db.profile.get(1);
    return data || null;
  } catch (err) {
    console.error("Error loading profile:", err);
    return null;
  }
}
